import { CustomIcon } from "components/icon/customIcon.component";
import React from "react";
import { Text } from "components/Typography/text.styled";
import { FontFamily, FontSize } from "config/font";
import { Color } from "config/colors";
import { Row } from "./pagination.styled";

type PaginationProps = {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;
  totalPages: number;
  small?: boolean;
};

export const Pagination: React.FC<PaginationProps> = ({
  setPage,
  page,
  totalPages,
  small
}) => {
  const haveNext = page + 1 !== totalPages && page !== totalPages;
  const havePrev = page !== 0;

  const handlePrevious = () => {
    setPage(page - 1);
  };

  const handleNext = () => {
    setPage(page + 1);
  };

  return (
    <Row>
      <CustomIcon
        onClick={() => {
          if (havePrev) {
            handlePrevious();
          }
        }}
        color={!havePrev ? Color.Disabled : Color.PitchBlack}
        name="paginationArrowLeft"
        size={small ? "14px": "20px"}
        style={{ cursor: havePrev ? "pointer" : "auto" }}
      />
      <Text
        align="center"
        fontSize={small? FontSize.Small : FontSize.H4}
        fontFamily={FontFamily.MontserratRegular}
        color={page == totalPages ? Color.Disabled : Color.PitchBlack}
        style={{ cursor: "none", marginTop: 30 }}
      >
        {page}
      </Text>
      <CustomIcon
        onClick={() => {
          if (haveNext) {
            handleNext();
          }
        }}
        name="paginationArrowRight"
        color={!haveNext ? Color.Disabled : Color.PitchBlack}
        size={small ? "14px": "20px"}
        style={{ cursor: haveNext ? "pointer" : "auto" }}
      />
    </Row>
  );
};
